"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconKeyLetterSmall = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconKeyLetterSmall = function SvgIconKeyLetterSmall(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.786 8H6.39v-.945H2.884V4.83h3.224v-.941H2.884V1.672h3.462V.727h-4.56V8z",
    fill: "currentColor"
  }));
};

exports.SvgIconKeyLetterSmall = SvgIconKeyLetterSmall;